import { render, staticRenderFns } from "./ConsentDialog.vue?vue&type=template&id=15d2c533&scoped=true&"
import script from "./ConsentDialog.vue?vue&type=script&lang=js&"
export * from "./ConsentDialog.vue?vue&type=script&lang=js&"
import style0 from "./ConsentDialog.vue?vue&type=style&index=0&id=15d2c533&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d2c533",
  null
  
)

export default component.exports